module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "value": _vm.value,
      "max-width": "700px"
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("View Client Data")]), _vm._v(" "), (_vm.client.acceptTerms) ? _c('v-alert', {
    attrs: {
      "dense": "",
      "text": "",
      "type": "success"
    }
  }, [_vm._v("\n      This client completed the\n      "), _c('strong', [_vm._v("Vendor Creation Form")]), _vm._v(".\n    ")]) : _vm._e(), _vm._v(" "), _c('v-card-text', [_c('v-form', [_c('v-layout', [_c('v-expansion-panels', {
    attrs: {
      "multiple": ""
    },
    model: {
      value: (_vm.panels),
      callback: function($$v) {
        _vm.panels = $$v
      },
      expression: "panels"
    }
  }, [_c('v-expansion-panel', [_c('v-expansion-panel-header', [_vm._v("Contact Details")]), _vm._v(" "), _c('v-expansion-panel-content', [_c('v-card-text', [_c('v-container', [_c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md12": ""
    }
  }, [_c('label', [_vm._v("Group")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.client.groupName || '-'))])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('label', [_vm._v("Client Name")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.client.name || '-'))])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('label', [_vm._v("Contact Number")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.client.phoneNumber || '-'))])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('label', [_vm._v("Address")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.client.address || '-'))])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('label', [_vm._v("Handled By")]), _vm._v(" "), _c('p', [_c('v-chip-group', {
    attrs: {
      "multiple": "",
      "active-class": "primary--text",
      "column": ""
    }
  }, _vm._l((_vm.dedicatedUserList), function(user) {
    return _c('v-chip', {
      key: user.id,
      attrs: {
        "small": ""
      }
    }, [_c('v-avatar', [_c('v-icon', [_vm._v("account_circle")])], 1), _vm._v("\n                               " + _vm._s(user.firstName || '-') + " " + _vm._s(user.lastName || '-') + "\n                            ")], 1)
  }), 1)], 1)]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('label', [_vm._v("Supported By")]), _vm._v(" "), _c('p', [_c('v-chip-group', {
    attrs: {
      "multiple": "",
      "active-class": "primary--text",
      "column": ""
    }
  }, _vm._l((_vm.supportingUserList), function(user) {
    return _c('v-chip', {
      key: user.id,
      attrs: {
        "small": ""
      }
    }, [_c('v-avatar', [_c('v-icon', [_vm._v("account_circle")])], 1), _vm._v("\n                               " + _vm._s(user.firstName || '-') + " " + _vm._s(user.lastName || '-') + "\n                            ")], 1)
  }), 1)], 1)]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('label', [_vm._v("Sale Person")]), _vm._v(" "), _c('p', [_c('v-chip', {
    attrs: {
      "small": ""
    }
  }, [_c('v-avatar', [_c('v-icon', [_vm._v("account_circle")])], 1), _vm._v("\n                            " + _vm._s(_vm.salePersonUser.firstName || '-') + "\n                          ")], 1)], 1)])], 1)], 1)], 1), _vm._v(" "), (_vm.client.contacts) ? _c('v-expansion-panels', {
    attrs: {
      "multiple": ""
    },
    model: {
      value: (_vm.contactPanels),
      callback: function($$v) {
        _vm.contactPanels = $$v
      },
      expression: "contactPanels"
    }
  }, [_c('v-expansion-panel', [_c('v-expansion-panel-header', [_vm._v("\n                      Contact Person Details\n                      "), _c('v-chip', {
    staticStyle: {
      "max-width": "30px",
      "margin-left": "5px"
    },
    attrs: {
      "small": ""
    }
  }, [_c('strong', [_vm._v(_vm._s(_vm.client.contacts.length))])])], 1), _vm._v(" "), _c('v-expansion-panel-content', _vm._l((_vm.client.contacts), function(contact, index) {
    return _c('v-list', {
      key: index,
      attrs: {
        "dense": ""
      }
    }, [(contact.includeEmail) ? _c('v-list-item', {
      staticClass: "justify-end",
      attrs: {
        "dense": ""
      }
    }, [_c('v-icon', {
      attrs: {
        "color": "green",
        "small": ""
      }
    }, [_vm._v("mdi-check")]), _vm._v("  Include in Email\n                          ")], 1) : _vm._e(), _vm._v(" "), _c('v-list-item', {
      attrs: {
        "dense": ""
      }
    }, [_c('v-layout', {
      attrs: {
        "wrap": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs12": "",
        "md12": ""
      }
    }, [_c('label', [_vm._v("Contact Person")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(contact.contactName || '-'))])])], 1)], 1), _vm._v(" "), _c('v-list-item', {
      attrs: {
        "dense": ""
      }
    }, [_c('v-layout', {
      attrs: {
        "wrap": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs12": "",
        "md12": ""
      }
    }, [_c('label', [_vm._v("Contact Email")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(contact.email || '-'))])])], 1)], 1), _vm._v(" "), _c('v-list-item', {
      attrs: {
        "dense": ""
      }
    }, [_c('v-layout', {
      attrs: {
        "wrap": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs12": "",
        "md12": ""
      }
    }, [_c('label', [_vm._v("Campaigns")]), _vm._v(" "), _c('p', _vm._l((contact.campaigns), function(item, index) {
      return _c('v-chip', {
        key: index,
        staticClass: "ma-1",
        attrs: {
          "small": ""
        }
      }, [_vm._v("\n                                  " + _vm._s(item.name) + "\n                                ")])
    }), 1)])], 1)], 1), _vm._v(" "), _c('v-divider', {
      staticClass: "ma-0 pa-0"
    })], 1)
  }), 1)], 1)], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-expansion-panel', [_c('v-expansion-panel-header', [_vm._v("Account Details")]), _vm._v(" "), _c('v-expansion-panel-content', [_c('v-card-text', [_c('v-container', [_c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('label', [_vm._v("Account Budget:")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.client.account.budget || '-'))])])], 1), _vm._v(" "), (_vm.client.account.deals) ? _c('div', [_c('v-divider', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.client.account.deals.length > 0),
      expression: "client.account.deals.length > 0"
    }]
  }), _vm._v(" "), _c('v-row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.client.account.deals.length > 0),
      expression: "client.account.deals.length > 0"
    }],
    staticStyle: {
      "margin-top": "20px",
      "margin-bottom": "20px"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-card', {
    attrs: {
      "text": "",
      "elevation": "0"
    }
  }, [_c('v-expansion-panels', _vm._l((_vm.client.account.deals), function(item, index) {
    return _c('v-expansion-panel', {
      key: index
    }, [_c('v-expansion-panel-header', {
      staticStyle: {
        "text-transform": "capitalize"
      },
      attrs: {
        "disable-icon-rotate": ""
      }
    }, [_c('span', [_c('p', {
      staticClass: "pr-2 pb-2 mb-0"
    }, [_vm._v("\n                                      " + _vm._s(_vm.getProductName(item.name)) + "\n                                    ")]), _vm._v(" "), (_vm.getMasterlistCheck(item.IO)) ? _c('v-chip', {
      attrs: {
        "color": "green",
        "outlined": "",
        "x-small": ""
      }
    }, [_vm._v("\n                                      Masterlist \n                                      "), _c('v-icon', {
      attrs: {
        "color": "success",
        "small": ""
      }
    }, [_vm._v("mdi-check")])], 1) : _vm._e()], 1), _vm._v(" "), _c('v-spacer')], 1), _vm._v(" "), _c('v-expansion-panel-content', [_c('v-card-text', [_c('v-row', {
      staticClass: "pa-0"
    }, [_c('v-col', {
      attrs: {
        "cols": "12",
        "sm": "12",
        "md": "6"
      }
    }, [_c('v-flex', {
      attrs: {
        "xs12": "",
        "md12": ""
      }
    }, [_c('label', [_vm._v("Deals Budget")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.budget || '-'))])])], 1), _vm._v(" "), _c('v-col', {
      attrs: {
        "cols": "12",
        "sm": "12",
        "md": "6"
      }
    }, [_c('v-flex', {
      attrs: {
        "xs12": "",
        "md12": ""
      }
    }, [_c('label', [_vm._v("IO")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.IO || '-'))])])], 1)], 1), _vm._v(" "), _c('v-row', {
      staticClass: "pa-0 mt-0"
    }, [_c('v-col', {
      attrs: {
        "cols": "12",
        "sm": "6",
        "md": "6"
      }
    }, [_c('v-flex', {
      attrs: {
        "xs12": "",
        "md12": ""
      }
    }, [_c('label', [_vm._v("Quote Acceptance Date")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.formattedDate(item.quoteAcceptanceDate) || '-'))])])], 1), _vm._v(" "), (item.cogsAmount) ? _c('v-col', {
      attrs: {
        "cols": "12",
        "sm": "6"
      }
    }, [_c('v-flex', {
      attrs: {
        "xs12": "",
        "md12": ""
      }
    }, [_c('label', [_vm._v("Markup COGS Amount")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.cogsAmount || '-'))])])], 1) : _vm._e()], 1), _vm._v(" "), _c('v-row', {
      staticClass: "pa-0 mt-0"
    }, [(item.vertical) ? _c('v-col', {
      attrs: {
        "cols": "12",
        "sm": "6"
      }
    }, [_c('v-flex', {
      attrs: {
        "xs12": "",
        "md12": ""
      }
    }, [_c('label', [_vm._v("Campaign Vertical")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.displayCampaignVerticals(item.vertical)))])])], 1) : _vm._e(), _vm._v(" "), (item.country) ? _c('v-col', {
      attrs: {
        "cols": "12",
        "sm": "6"
      }
    }, [_c('v-flex', {
      attrs: {
        "xs12": "",
        "md12": ""
      }
    }, [_c('label', [_vm._v("Country")]), _vm._v(" "), _c('p', _vm._l((item.country), function(item, index) {
      return _c('v-chip', {
        key: index,
        staticClass: "ma-1",
        attrs: {
          "small": ""
        }
      }, [_vm._v("\n                                              " + _vm._s(item.name) + "\n                                            ")])
    }), 1)])], 1) : _vm._e()], 1), _vm._v(" "), _c('v-row', {
      staticClass: "pa-0 mt-0"
    }, [_c('v-col', {
      attrs: {
        "cols": "12",
        "sm": "6"
      }
    }, [_c('v-flex', {
      attrs: {
        "xs12": "",
        "md6": ""
      }
    }, [_c('label', [_vm._v("Client Type")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.getClientTypeDisplayValue(item.clientType)))])])], 1), _vm._v(" "), _c('v-col', {
      attrs: {
        "cols": "12",
        "sm": "6"
      }
    }, [_c('v-flex', {
      attrs: {
        "xs12": "",
        "md6": ""
      }
    }, [_c('label', [_vm._v("Remarks")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.remarks || '-'))])])], 1)], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
      attrs: {
        "cols": "12",
        "sm": "12"
      }
    }, [_c('v-expansion-panels', _vm._l((item.products), function(product, pindex) {
      return _c('v-expansion-panel', {
        key: pindex
      }, [_c('v-expansion-panel-header', {
        staticStyle: {
          "text-transform": "capitalize"
        }
      }, [_vm._v(_vm._s(_vm.getProductName(product.name)))]), _vm._v(" "), _c('v-expansion-panel-content', [_c('v-card-text', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (product.name.toLowerCase() === 'storytell'),
          expression: "product.name.toLowerCase() === 'storytell'"
        }]
      }, [_c('v-layout', {
        attrs: {
          "wrap": ""
        }
      }, [_c('v-flex', {
        attrs: {
          "xs12": "",
          "md6": ""
        }
      }, [_c('label', [_vm._v("Account Budget")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(product.budget || '-'))])]), _vm._v(" "), _c('v-flex', {
        attrs: {
          "xs12": "",
          "md6": ""
        }
      }, [_c('label', [_vm._v("No. of Campaigns")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(product.noOfCampaigns || '-'))])])], 1), _vm._v(" "), _c('v-layout', {
        attrs: {
          "wrap": ""
        }
      }, [_c('v-flex', {
        attrs: {
          "xs12": "",
          "md6": ""
        }
      }, [_c('label', [_vm._v("Total Outreach")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(product.totalOutReach || '-'))])]), _vm._v(" "), _c('v-flex', {
        attrs: {
          "xs12": "",
          "md6": ""
        }
      }, [_c('label', [_vm._v("Total Engagement")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(product.totalEngagement || '-'))])])], 1), _vm._v(" "), _c('v-layout', {
        attrs: {
          "wrap": ""
        }
      }, [_c('v-flex', {
        attrs: {
          "xs12": "",
          "md6": ""
        }
      }, [_c('label', [_vm._v("Min. Original Contents")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(product.minContent || '-'))])]), _vm._v(" "), _c('v-flex', {
        attrs: {
          "xs12": "",
          "md6": ""
        }
      }, [_c('label', [_vm._v("Max. Original Contents")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(product.maxContent || '-'))])])], 1), _vm._v(" "), _c('v-layout', {
        attrs: {
          "wrap": ""
        }
      }, [_c('v-flex', {
        attrs: {
          "xs12": "",
          "md6": ""
        }
      }, [_c('label', [_vm._v("Created Date")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.formattedDate(product.createdDate) || '-'))])])], 1)], 1), _vm._v(" "), _c('v-card-text', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (product.name.toLowerCase() === 'amplify'),
          expression: "product.name.toLowerCase() === 'amplify'"
        }]
      }, [_c('v-layout', {
        attrs: {
          "wrap": ""
        }
      }, [_c('v-flex', {
        attrs: {
          "xs12": "",
          "md6": ""
        }
      }, [_c('label', [_vm._v("Account Budget")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(product.budget || '-'))])]), _vm._v(" "), _c('v-flex', {
        attrs: {
          "xs12": "",
          "md6": ""
        }
      }, [_c('label', [_vm._v("Views")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(product.views || '-'))])])], 1), _vm._v(" "), _c('v-layout', {
        attrs: {
          "wrap": ""
        }
      }, [_c('v-flex', {
        attrs: {
          "xs12": "",
          "md6": ""
        }
      }, [_c('label', [_vm._v("Min. Original Contents")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(product.minContent || '-'))])]), _vm._v(" "), _c('v-flex', {
        attrs: {
          "xs12": "",
          "md6": ""
        }
      }, [_c('label', [_vm._v("Max. Original Contents")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(product.maxContent || '-'))])])], 1), _vm._v(" "), _c('v-layout', {
        attrs: {
          "wrap": ""
        }
      }, [_c('v-flex', {
        attrs: {
          "xs12": "",
          "md6": ""
        }
      }, [_c('label', [_vm._v("No. of Contents")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(product.noOfContents || '-'))])]), _vm._v(" "), _c('v-flex', {
        attrs: {
          "xs12": "",
          "md6": ""
        }
      }, [_c('label', [_vm._v("Duration")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(product.duration || '-') + " " + _vm._s((product.duration > 1 ? 'Months' : 'Month')))])])], 1), _vm._v(" "), _c('v-layout', {
        attrs: {
          "wrap": ""
        }
      }, [_c('v-flex', {
        attrs: {
          "xs12": "",
          "md6": ""
        }
      }, [_c('label', [_vm._v("Created Date")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.formattedDate(product.createdDate) || '-'))])])], 1)], 1), _vm._v(" "), _c('v-card-text', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (product.name.toLowerCase() === 'uncut'),
          expression: "product.name.toLowerCase() === 'uncut'"
        }]
      }, [_c('v-layout', {
        attrs: {
          "wrap": ""
        }
      }, [_c('v-flex', {
        attrs: {
          "xs12": "",
          "md6": ""
        }
      }, [_c('label', [_vm._v("Account Budget")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(product.budget || '-'))])]), _vm._v(" "), _c('v-flex', {
        attrs: {
          "xs12": "",
          "md6": ""
        }
      }, [_c('label', [_vm._v("Total Outreach")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(product.totalOutReach || '-'))])])], 1), _vm._v(" "), _c('v-layout', {
        attrs: {
          "wrap": ""
        }
      }, [_c('v-flex', {
        attrs: {
          "xs12": "",
          "md6": ""
        }
      }, [_c('label', [_vm._v("Min. Original Contents")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(product.minContent || '-'))])]), _vm._v(" "), _c('v-flex', {
        attrs: {
          "xs12": "",
          "md6": ""
        }
      }, [_c('label', [_vm._v("Max. Original Contents")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(product.maxContent || '-'))])])], 1), _vm._v(" "), _c('v-layout', {
        attrs: {
          "wrap": ""
        }
      }, [_c('v-flex', {
        attrs: {
          "xs12": "",
          "md12": ""
        }
      }, [_c('label', [_vm._v("KPI Onboarded")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(product.kpiOnboarded || '-'))])])], 1), _vm._v(" "), _c('v-layout', {
        attrs: {
          "wrap": ""
        }
      }, [_c('v-flex', {
        attrs: {
          "xs12": "",
          "md6": ""
        }
      }, [_c('label', [_vm._v("Created Date")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.formattedDate(product.createdDate) || '-'))])])], 1)], 1), _vm._v(" "), _c('v-card-text', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (product.name.toLowerCase() === 'aok'),
          expression: "product.name.toLowerCase() === 'aok'"
        }]
      }, [_c('v-layout', {
        attrs: {
          "wrap": ""
        }
      }, [_c('v-flex', {
        attrs: {
          "xs12": "",
          "md6": ""
        }
      }, [_c('label', [_vm._v("Account Budget")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(product.budget || '-'))])]), _vm._v(" "), _c('v-flex', {
        attrs: {
          "xs12": "",
          "md6": ""
        }
      }, [_c('label', [_vm._v("Total Outreach")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(product.totalOutReach || '-'))])])], 1), _vm._v(" "), _c('v-layout', {
        attrs: {
          "wrap": ""
        }
      }, [_c('v-flex', {
        attrs: {
          "xs12": "",
          "md6": ""
        }
      }, [_c('label', [_vm._v("Min. Original Contents")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(product.minContent || '-'))])]), _vm._v(" "), _c('v-flex', {
        attrs: {
          "xs12": "",
          "md6": ""
        }
      }, [_c('label', [_vm._v("Max. Original Contents")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(product.maxContent || '-'))])])], 1), _vm._v(" "), _c('v-layout', {
        attrs: {
          "wrap": ""
        }
      }, [_c('v-flex', {
        attrs: {
          "xs12": "",
          "md12": ""
        }
      }, [_c('label', [_vm._v("KPI Onboarded")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(product.kpiOnboarded || '-'))])])], 1), _vm._v(" "), _c('v-layout', {
        attrs: {
          "wrap": ""
        }
      }, [_c('v-flex', {
        attrs: {
          "xs12": "",
          "md6": ""
        }
      }, [_c('label', [_vm._v("Created Date")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.formattedDate(product.createdDate) || '-'))])])], 1)], 1), _vm._v(" "), _c('v-card-text', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (product.name.toLowerCase() === 'others'),
          expression: "product.name.toLowerCase() === 'others'"
        }]
      }, [_c('v-layout', {
        attrs: {
          "wrap": ""
        }
      }, [_c('v-flex', {
        attrs: {
          "xs12": "",
          "md6": ""
        }
      }, [_c('label', [_vm._v("Account Budget")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(product.budget || '-'))])])], 1), _vm._v(" "), _c('v-layout', {
        attrs: {
          "wrap": ""
        }
      }, [_c('v-flex', {
        attrs: {
          "xs12": "",
          "md6": ""
        }
      }, [_c('label', [_vm._v("Remark")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(product.remark || '-'))])])], 1), _vm._v(" "), _c('v-layout', {
        attrs: {
          "wrap": ""
        }
      }, [_c('v-flex', {
        attrs: {
          "xs12": "",
          "md6": ""
        }
      }, [_c('label', [_vm._v("Nature of deal")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(product.natureOfDeal ? _vm.displayNatureOfDeals(product.natureOfDeal) : '-'))])])], 1)], 1)], 1)], 1)
    }), 1)], 1)], 1)], 1)], 1)], 1)
  }), 1)], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.client.account.products) ? _c('div', [_c('v-divider', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.client.account.products.length > 0),
      expression: "client.account.products.length > 0"
    }]
  }), _vm._v(" "), _c('v-row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.client.account.products.length > 0),
      expression: "client.account.products.length > 0"
    }],
    staticStyle: {
      "margin-top": "20px",
      "margin-bottom": "20px"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-card', {
    attrs: {
      "text": "",
      "elevation": "0"
    }
  }, [_c('v-expansion-panels', {
    attrs: {
      "multiple": ""
    }
  }, _vm._l((_vm.client.account.products), function(item, index) {
    return _c('v-expansion-panel', {
      key: index
    }, [_c('v-expansion-panel-header', {
      staticStyle: {
        "text-transform": "capitalize"
      }
    }, [_vm._v(_vm._s(_vm.getProductName(item.name)))]), _vm._v(" "), _c('v-expansion-panel-content', [_c('v-card-text', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.name.toLowerCase() === 'storytell'),
        expression: "item.name.toLowerCase() === 'storytell'"
      }]
    }, [_c('v-layout', {
      attrs: {
        "wrap": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs12": "",
        "md6": ""
      }
    }, [_c('label', [_vm._v("Account Budget")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.budget))])]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": "",
        "md6": ""
      }
    }, [_c('label', [_vm._v("No. of Campaigns")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.noOfCampaigns))])]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": "",
        "md6": ""
      }
    }, [_c('label', [_vm._v("Total Outreach")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.totalOutReach))])]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": "",
        "md6": ""
      }
    }, [_c('label', [_vm._v("Total Engagement")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.totalEngagement))])]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": "",
        "md6": ""
      }
    }, [_c('label', [_vm._v("Min. Original Contents")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.minContent))])]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": "",
        "md6": ""
      }
    }, [_c('label', [_vm._v("Max. Original Contents")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.maxContent))])]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": "",
        "md6": ""
      }
    }, [_c('label', [_vm._v("Created Date")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.formattedDate(item.createdDate)))])])], 1)], 1), _vm._v(" "), _c('v-card-text', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.name.toLowerCase() === 'amplify'),
        expression: "item.name.toLowerCase() === 'amplify'"
      }]
    }, [_c('v-layout', {
      attrs: {
        "wrap": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs12": "",
        "md6": ""
      }
    }, [_c('label', [_vm._v("Account Budget")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.budget))])]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": "",
        "md6": ""
      }
    }, [_c('label', [_vm._v("Views")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.views))])]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": "",
        "md6": ""
      }
    }, [_c('label', [_vm._v("Min. Original Contents")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.minContent))])]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": "",
        "md6": ""
      }
    }, [_c('label', [_vm._v("Max. Original Contents")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.maxContent))])]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": "",
        "md6": ""
      }
    }, [_c('label', [_vm._v("No. of Contents")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.noOfContents))])]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": "",
        "md6": ""
      }
    }, [_c('label', [_vm._v("Duration")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.duration) + " " + _vm._s((item.duration > 1 ? 'Months' : 'Month')))])]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": "",
        "md6": ""
      }
    }, [_c('label', [_vm._v("Created Date")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.formattedDate(item.createdDate)))])])], 1)], 1), _vm._v(" "), _c('v-card-text', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.name.toLowerCase() === 'uncut'),
        expression: "item.name.toLowerCase() === 'uncut'"
      }]
    }, [_c('v-layout', {
      attrs: {
        "wrap": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs12": "",
        "md6": ""
      }
    }, [_c('label', [_vm._v("Account Budget")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.budget))])]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": "",
        "md6": ""
      }
    }, [_c('label', [_vm._v("Min. Original Contents")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.minContent))])]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": "",
        "md6": ""
      }
    }, [_c('label', [_vm._v("Max. Original Contents")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.maxContent))])]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": "",
        "md12": ""
      }
    }, [_c('label', [_vm._v("KPI Onboarded")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.kpiOnboarded || '-'))])]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": "",
        "md6": ""
      }
    }, [_c('label', [_vm._v("Created Date")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.formattedDate(item.createdDate)))])])], 1)], 1), _vm._v(" "), _c('v-card-text', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.name.toLowerCase() === 'aok'),
        expression: "item.name.toLowerCase() === 'aok'"
      }]
    }, [_c('v-layout', {
      attrs: {
        "wrap": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs12": "",
        "md6": ""
      }
    }, [_c('label', [_vm._v("Account Budget")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.budget))])]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": "",
        "md6": ""
      }
    }, [_c('label', [_vm._v("Total Outreach")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.totalOutReach))])]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": "",
        "md6": ""
      }
    }, [_c('label', [_vm._v("Min. Original Contents")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.minContent))])]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": "",
        "md6": ""
      }
    }, [_c('label', [_vm._v("Max. Original Contents")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.maxContent))])]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": "",
        "md12": ""
      }
    }, [_c('label', [_vm._v("KPI Onboarded")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.kpiOnboarded || '-'))])]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": "",
        "md6": ""
      }
    }, [_c('label', [_vm._v("Created Date")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.formattedDate(item.createdDate)))])])], 1)], 1), _vm._v(" "), _c('v-card-text', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.product.name.toLowerCase() === 'others'),
        expression: "product.name.toLowerCase() === 'others'"
      }]
    }, [_c('v-layout', {
      attrs: {
        "wrap": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs12": "",
        "md6": ""
      }
    }, [_c('label', [_vm._v("Account Budget")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.product.budget || '-'))])]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": "",
        "md6": ""
      }
    }, [_c('label', [_vm._v("Remark")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.product.remark || '-'))])]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": "",
        "md6": ""
      }
    }, [_c('label', [_vm._v("Nature of deal")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.product.natureOfDeal || '-'))])])], 1)], 1)], 1)], 1)
  }), 1)], 1)], 1)], 1)], 1) : _vm._e()], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-expansion-panel', [_c('v-expansion-panel-header', [_vm._v("Billing Details")]), _vm._v(" "), _c('v-expansion-panel-content', [_c('v-card-text', [_c('v-container', [_c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('label', [_vm._v("Payment Mode")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.clientPaymentModesDisplay(_vm.client.paymentMode) || '-'))])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('label', [_vm._v("Billing Address")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.client.billingAddress || '-'))])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('label', [_vm._v("Billing Contact")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.client.billingPhoneNumber || '-'))])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('label', [_vm._v("Billing Email")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.client.billingEmail || '-'))])])], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [_vm._v("Close")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a5be5348"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Client/ViewClientModal.vue
// module id = 2258
// module chunks = 0